import { isValidElement } from 'react';
import cardDefaultStyle from './cardDefaultStyle';
import { cardMediaStyle } from './cardMediaStyle';
const cardStyleBuilder = (theme, mediaPosition, width) => {
  const style = mediaPosition ? cardMediaStyle(theme, mediaPosition, width) : cardDefaultStyle(theme, width);
  return style;
};
export const resolvePadding = (padding, media, mediaPosition) => {
  let paddingProps;
  if (/*#__PURE__*/isValidElement(media)) {
    const props = media.props;
    paddingProps = props.padding ? props.padding : '16px';
  }
  if (padding) {
    return padding;
  } else if (mediaPosition && media) {
    return paddingProps;
  }
  return '16px';
};
export default cardStyleBuilder;